import type { FreightVehicle } from "../schemas/validators/freightShipment.lib";

export const SITE_PLACE = {
  BUSINESS: "business",
  RESIDENCE: "residence",
  CONSTRUCTION_SITE: "construction_site",
  TRADE_SHOW: "trade_show",
  LIMITED_ACCESS: "limited_access",
} as const;

export type SitePlace = (typeof SITE_PLACE)[keyof typeof SITE_PLACE];

export const LIMITED_ACCESS_KIND = {
  SCHOOL: "school",
  MILITARY: "military",
  PLACE_OF_WORSHIP: "place_of_worship",
  FARM: "farm",
  SELF_STORAGE: "self_storage",
  CORRECTIONAL: "correctional",
  GOVERNMENT: "government",
  OTHER: "other",
} as const;

export type LimitedAccessKind = (typeof LIMITED_ACCESS_KIND)[keyof typeof LIMITED_ACCESS_KIND];

export const SITE_INSIDE = {
  NONE: "none",
  GROUND_FLOOR: "ground_floor",
  UPSTAIRS: "upstairs",
  BACK_OF_HOUSE: "back_of_house",
  LIVING_SPACE: "living_space",
} as const;

export type SiteInside = (typeof SITE_INSIDE)[keyof typeof SITE_INSIDE];

export const PICKUP_SITE_ACCESS = {
  KNOWN: "known",
  UNKNOWN: "unknown",
  CONFLICT: "conflict",
} as const;

export type PickupSiteAccessKind = (typeof PICKUP_SITE_ACCESS)[keyof typeof PICKUP_SITE_ACCESS];

export const SITE_STOP = {
  PICKUP: "pickup",
  DELIVERY: "delivery",
} as const;

export type SiteStop = (typeof SITE_STOP)[keyof typeof SITE_STOP];

export const SITE_VEHICLES = ["cargoVan", "boxTruck", "dryVan", "flatbed"] as const satisfies readonly FreightVehicle[];
